<ng-container *ngIf="isLoading; else legacyDisplay">
  <div role="alert" aria-live="polite" aria-label="Please wait... Your content is loading" aria-busy="true">
    <div class="rs-spinner"></div>
  </div>
</ng-container>

<ng-template #legacyDisplay>
  <section *ngIf="!isComingFromIntent; else intentSection" id="addProduct" class="rs-content-wrapper rs-header-has-level2">
    <main id="maincontent" role="main">
      <section class="rs-es-first-section">
        <mprd-back-link></mprd-back-link>
        <div class="row">
          <div class="columns small-12">
            <h1 class="rs-txt-c2">{{ 'products.addProduct.title' | translate }}</h1>
            <div class="rs-panel-big rs-bg-c2 clearfix">
              <div class="rs-flex-row rs-flex-middle rs-xpandgrid">
                <div class="rs-flex-columns small-12 medium-6 rs-flex-top">
                  <mprd-fiber-migration
                    *ngIf="isFiberEligible && customer$ | async as customer"
                    [isOutOfPack]="outOfPack"
                    [isSE]="customer.isSE()"
                    [isRES]="customer.isRES()"
                    [pack]="dataForAddProduct"
                    [lomKey]="installationAddresses[dataForAddProduct.addressKey]?.lomKey"
                    [greyBackground]="true"
                  ></mprd-fiber-migration>
                  <div *ngIf="packCtaProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Packs icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.pack' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of packCtaProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="mobileCtaProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Mobile icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.mobile' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of mobileCtaProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToMobileCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="internetProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Internet icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.internet' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of internetProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToInternetCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="tvProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Television icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.tv' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of tvProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToTvCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="securityProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Norton-security icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.security' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of securityProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="fixedLineProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Telephony icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.fixedline' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of fixedLineProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <div *ngIf="deviceProducts.length > 0">
                    <div class="rs-flex-row rs-flex-middle">
                      <div class="rs-flex-columns rs-flex-shrink">
                        <div class="rs-padding-bottom1">
                          <i
                            class="icon-Devices icon-lh rs-txt-s8 rs-txt-primary"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div>
                        <h3 class="rs-tit6">
                          {{ 'products.addProduct.category.devices' | translate }}
                        </h3>
                      </div>
                    </div>
                    <div class="rs-entrypoint-container">
                      <a
                        *ngFor="let CTAOption of deviceProducts"
                        href="javascript:void(0)"
                        class="rs-entrypoint"
                        (click)="goToCta(CTAOption)"
                        [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                        [attr.data-cy]="'addProductModel'"
                      >
                        <ng-container
                          *ngFor="
                          let icon of getCtaProductIcons(CTAOption);
                          count as count;
                          index as index
                        "
                        >
                          <ng-container *ngIf="count > 1 && index < 1">
                            <i class="icon-lh rs-entrypoint-icon icon-Packs" aria-hidden="true"></i>
                          </ng-container>
                          <ng-container *ngIf="count == 1">
                            <i
                              class="icon-lh rs-entrypoint-icon"
                              aria-hidden="true"
                              [ngClass]="icon"
                            ></i>
                          </ng-container>
                        </ng-container>
                        <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </div>
                  </div>
                  <hr />
                  <div class="rs-entrypoint-container">
                    <a
                      *ngFor="let CTAOption of otherProducts"
                      href="javascript:void(0)"
                      class="rs-entrypoint"
                      (click)="goToCta(CTAOption)"
                      [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                      [attr.data-cy]="'addProductModel'"
                    >
                      <ng-container
                        *ngFor="
                        let icon of getCtaProductIcons(CTAOption);
                        count as count;
                        index as index
                      "
                      >
                        <ng-container *ngIf="count > 1 && index < 1">
                          <i class="icon-lh rs-entrypoint-icon icon-Packs" aria-hidden="true"></i>
                        </ng-container>
                        <ng-container *ngIf="count == 1">
                          <i
                            class="icon-lh rs-entrypoint-icon"
                            aria-hidden="true"
                            [ngClass]="icon"
                          ></i>
                        </ng-container>
                      </ng-container>
                      <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                      <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                    </a>
                    <ng-container *ngIf="!isScarlet">
                      <a
                        target="_self"
                        href="{{ 'products.addProduct.reload.online.link' | translate }}"
                        class="rs-entrypoint"
                      >
                        <i class="icon-Reload icon-lh rs-entrypoint-icon" aria-hidden="true"></i>
                        <span class="rs-entrypoint-title">{{
                            'products.addProduct.reload.online' | translate
                          }}</span>
                        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                      </a>
                    </ng-container>
                  </div>
                </div>
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="text-center show-for-medium-up">
                    <img alt="" src="{{ 'products.addProduct.hero.img.path' | translate }}" />
                  </div>
                  <div class="rs-me"></div>
                  <h3 class="rs-tit6 rs-txt-c1">{{ 'products.addProduct.hero.text' | translate }}</h3>
                  <a
                    href="javascript:void(0)"
                    (click)="redirectToContact()"
                    class="rs-btn rs-btn-third"
                  >
                    {{ 'products.addProduct.hero.link.label' | translate }}
                    <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</ng-template>


<ng-template #intentSection>
  <section>
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <h1 class="rs-tit1 rs-padding-bottom1" *ngIf="titleWithCustoumerName"> {{ titleWithCustoumerName }}</h1>
        <h1 class="rs-tit1">{{'products.addProduct.subtitleName' | translate }}</h1>

        <div *ngIf="packCtaProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.pack' | translate }}
          </p>
          <div class="row">
            <div class="rs-entrypoint-container">
              <div class="columns small-12 medium-8">
                <a
                  *ngFor="let CTAOption of packCtaProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Packs icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="mobileCtaProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.mobile' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of mobileCtaProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToMobileCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Mobile icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="internetProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.internet' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of internetProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToInternetCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Internet icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="tvProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.tv' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of tvProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToTvCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Television icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="securityProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.security' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of securityProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Norton-security icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="fixedLineProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.fixedline' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of fixedLineProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Telephony icon-lh rs-txt-s8 rs-txt-primary"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="deviceProducts.length > 0">
          <p class="rs-tit4-sp">
            {{ 'products.addProduct.category.devices' | translate }}
          </p>
          <div class="row">
            <div class="columns small-12 medium-8">
              <div class="rs-entrypoint-container">
                <a
                  *ngFor="let CTAOption of deviceProducts"
                  href="javascript:void(0)"
                  class="rs-entrypoint"
                  (click)="goToCta(CTAOption)"
                  [attr.data-tms-button-name]="getCtaProductTaggingName(CTAOption)"
                  [attr.data-cy]="'addProductModel'"
                >
                  <i
                    class="icon-Devices icon-lh rs-entrypoint-icon"
                    aria-hidden="true"
                  ></i>
                  <span class="rs-entrypoint-title">{{ getCtaProductLabel(CTAOption) }}</span>
                  <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="rs-le2"></div>

        <div class="rs-footer-ays-box">
          <h3 class="rs-txt-purple rs-txt-primary rs-txt-s4">{{ 'products.addProduct.hero.text' | translate }}</h3>
          <a
            href="javascript:void(0)"
            (click)="redirectToContact()"
            class="rs-btn rs-btn-third"
          >
            {{ 'products.addProduct.heroSimplified.Link.label' | translate }}
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="rs-le2"></div>
  </section>
</ng-template>
